var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-12',[_c('div',{staticClass:"wh1",attrs:{"id":"assess-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }